"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PageContexts_1 = require("../Contexts/PageContexts");
const noop = () => { };
/**
 *  The repeatable wrapper is a component which wraps any repeatable form control and manages the additional and subtraction of individual repeated form controls
 * It will also render a single item for non-repeatable form controls
 * @param controlPath The defined path of this control, as determined by final-form
 * @param controlDefinition The definition of this control. This is primarily used to determine the number of repeatable values
 * @param renderControl The render function which will be called for each item in a repeatable control
 */
const RepeatableRender = props => {
    const { controlMap } = (0, PageContexts_1.useControlProvider)();
    const { controlPath, controlDefinition, renderControl, value } = props;
    if (controlDefinition.repeats && Array.isArray(value)) {
        return (react_1.default.createElement(controlMap.RepeatWrapper, null, value.map((val, i) => {
            return renderControl(Object.assign(Object.assign({}, props), { controlPath: `${controlPath}[${i}]`, value: val, key: `${controlPath}-${i}`, index: 0, onAddClick: noop, onRemoveClick: noop, repeatable: true, repeatCount: 1 }));
        })));
    }
    else {
        return renderControl(Object.assign(Object.assign({}, props), { key: controlPath, index: 0, onAddClick: noop, onRemoveClick: noop, repeatable: false, repeatCount: 1 }));
    }
};
exports.default = react_1.default.memo(RepeatableRender);
